<template>
	<div>
		<el-form ref="splitform" :model="form" label-width="100px" size="mini">
			<el-form-item label="订单号" class="item">
				<el-input v-model="form.ordercode" readonly></el-input>
			</el-form-item>
			<el-form-item label="系统单号" class="item">
				<el-input v-model="form.tptid" readonly></el-input>
			</el-form-item>
			<el-form-item label="买家ID" class="item">
				<el-input v-model="form.nickname" readonly></el-input>
			</el-form-item>
			<el-form-item label="归属人" class="item">
				<staff v-model="form.staffid" @modalsubmit="staffchange" />
			</el-form-item>
		</el-form>
	</div>
</template>
<style>

</style>
<style scoped>
	.item {
		margin-bottom: 4px;
	}
</style>
<script>
	import staff from '@_system/components/formcomponents/common/select/staff/select.vue'
	export default {
		name: 'customerDistributionIndex',
		props: {
			row: {
				type: Object,
				default: () => {
					return null
				}
			},
		},
		data() {
			return {
				form: {
					id: 0,
					tptid: '',
					ordercode: '',
					nickname: '',
					staffid: null,
				}
			}
		},
		watch: {

		},
		mounted() {
			this.form.id = this.row.id
			this.form.tptid = this.row.tptid
			this.form.ordercode = this.row.ordercode
			this.form.nickname = this.row.nickname
			this.form.staffid = this.row.staffid
		},
		computed: {

		},

		methods: {
			submit() {
				if (!this.form.staffid) {
					this.$message.error('分配人不能为空')
					return false
				} else {
					return this.form
				}
			},
			staffchange(e){
				this.form.staffid = e.data
			
			}
		},
		components: {
			staff
		}
	}
</script>
